import { Stack, Box } from "@mui/material";

export default function KakaoChatItem() {
  return (
    <Stack
      flexDirection={"row"}
      alignItems={"center"}
      gap={1}
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <img 
          src="/kakao.png" 
          alt="카카오톡 문의"
          style={{
            width: "20px",
            height: "20px",
            objectFit: "contain",
            display: "block",
          }}
        />
      </Box>
      카카오톡 문의
    </Stack>
  );
}
